import script from "./ProductGalleryEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductGalleryEditor.vue?vue&type=script&setup=true&lang=js"

import "./ProductGalleryEditor.vue?vue&type=style&index=0&id=e0827e12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0827e12"]])

export default __exports__